import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { AuthService } from 'src/app/services/auth.service';
import { AWSLambda } from 'src/app/AWSLambda.service';
import { Auth } from 'aws-amplify';
import { tuiAsOptionContent } from '@taiga-ui/core';

@Component({
  selector: 'app-edit-config',
  templateUrl: './edit-config.component.html',
})
export class EditConfigComponent implements OnInit {

  user = inject(AuthenticatorService).user;
  auth = inject(AuthService);
  _snackBar = inject(MatSnackBar);
  router = inject(Router);

  editForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private lambda: AWSLambda,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    sessionStorage.setItem('back_url', '/backoffice/configs');

    this.route.queryParams.subscribe(params => {
      this.editForm = this.fb.group({
        id: [{ value: params['id'] || '', disabled: true }],
        createdAt: [{ value: params['createdAt'] || '', disabled: true }],
        updatedAt: [{ value: params['updatedAt'] || '', disabled: true }],
        nombre: [params['nombre'] || ''],
        Modulo: [{ value: params['Modulo'] || '', disabled: true }],
        valor: [params['valor'] || ''],
        Descripcion: [params['Descripcion'] || ''],
        activo: [+params['activo'] || 0]
      });
    });
  }

  async onUpdate(): Promise<void> {
    try {
      this.user = await Auth.currentAuthenticatedUser();
    } catch (error) {
      this.auth.logout();
      return;
    }

    const raw = this.editForm.getRawValue();  // Incluye disabled
    const toUpdate: any = {};

    // Solo campos editables que el backend espera
    const editableFields = ['valor', 'nombre', 'activo', 'Descripcion'];
    editableFields.forEach(field => {
      if (raw[field] !== undefined) {
        toUpdate[field] = raw[field];
      }
    });

    toUpdate.id = raw.id;

    if (!toUpdate.id) {
      this._snackBar.open('ID no válido.', 'Cerrar', { duration: 5000 });
      return;
    }
   

    try {
      const result: any = await this.lambda.getLambdaFunction("lambda", "/Configs", {
        queryStringParameters: {
          opcion: "5",
          toUpdate: JSON.stringify(toUpdate)
        }
      });

      if (result.ok) {
        this._snackBar.open('Configuración actualizada correctamente', 'Cerrar', {
          duration: 5000,
        });

        const backUrl = sessionStorage.getItem('back_url');
        if (backUrl) {
          this.router.navigate([backUrl], { replaceUrl: true });
        } else {
          this.goBack();
        }
      } else {
        this._snackBar.open('Error: ' + result.message, 'Cerrar', { duration: 5000 });
      }
    } catch (error) {
      this._snackBar.open('Error al actualizar la configuración.', 'Cerrar', { duration: 5000 });
      console.error(error);
    }
  }

  goBack(): void {
    this.router.navigate(['/backoffice/configs'], { replaceUrl: true });
  }
}
